import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import { studyEDCLupReportingServices } from "../../../../APIServices/studyEDCLupReportingServices";

const UpdateReportCategory = ({ Show, Hide, Title, categoryData, setCategoryData, setCategoryId, getLupReportCategorysData }) => {
  let { studyId } = useParams();
  const [categoryName, setCategoryName] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateLupReportCategoryData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Category!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {}
        userData.id = categoryData?._id
        userData.categoryId = categoryData?.categoryId
        userData.name = categoryName
        userData.studyId = studyId
        let data = await studyEDCLupReportingServices.updateLupReportCategoryData(userData);
        if (data?.statusCode === 200) {
          getLupReportCategorysData();
          setCategoryData("")
          setCategoryId("")
          Hide()
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setCategoryName(categoryData?.name);
  }, [categoryData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Category Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              className="fontSize12"
              placeholder="Enter Category"
              onChange={(e) => setCategoryName(e.target.value)}
              value={categoryName}
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={updateLupReportCategoryData}
            disabled={!categoryName || buttonLoader}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Category"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateReportCategory;
